import { EnvCommon } from '@bcflit-env/types';

// // eslint-disable-next-line @typescript-eslint/typedef
export const envBaseCommon: Pick<
  EnvCommon,
  'langs' | 'svgIconConfig' | 'brandInfo' | 'baseDomainName' | 'additionalI18nLangs'
> = {
  baseDomainName: 'tikalcasino',
  langs: ['en', 'pl', 'fr', 'de'],
  additionalI18nLangs: ['en_US'],
  svgIconConfig: {
    brand: 'lit-tikalcasino',
    hostUrl: 'https://image-assets-server-dot-cms-headless-gae.ew.r.appspot.com/'
  },
  brandInfo: { brandName: 'Tikal Casino', supportEmail: 'support@tikalcasino.com', host: 'tikalcasino.com' }
};
